import '../../styles/templates/password.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Password Template');
});
